module.exports = function getResource(label, vars = []) {
    const resources = {
        selectOne: 'Sélectionner une option',
        selectAllThatApply: 'Sélectionner toutes les options qui s’appliquent',
        skinType: 'Type de peau',
        skinConcerns: 'Préoccupations cutanées',
        skinTone: 'Ton de peau',
        hairDescrible: 'Type de cheveux',
        hairConcerns: 'Problèmes de cheveux',
        hairColor: 'Couleur des cheveux',
        eyeColor: 'Couleur des yeux',
        ageRange: 'Tranche d’âge',
        fragrancePreferences: 'Préférences parfums',
        shoppingPreferences: 'Préférences magasinage',
        ingredientPreferences: 'Préférences ingrédients',
        favoriteBrands: 'Marques favorites',
        colorIQ: 'Color IQ',
        captured: 'Capturé ',
        viewAll: 'Voir tout'
    };
    return resources[label];
};
